import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/ContactsModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { getData as getClients } from '../../../models/ClientsModel';
import { DatePicker, MyReactSelect, Text, TextEmail, TextNumber } from '../../inputs/inputs';
import { formatDataBeforeDisplay, formatDataBeforeSend, quickAddClient, validorSettings } from '../../../helpers/GeneralHelper';
import SimpleReactValidator from 'simple-react-validator';
import { QuickAdd } from '../../modals/QuickAdd';
import AdminLayout from "../../layout/AdminLayout";
import PageHeader from "../../common/PageHeader";
import { Helmet } from "react-helmet";
import { checkPermission } from "../../../helpers/GeneralHelper";

export default function ContactViewEdit () {

    const location = useLocation();
    const isEdit = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'edit';
    const isView = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'view';
    const module = {
        title: isEdit ? 'Edit POC' : 'View POC',
        singularTitle: 'POC',
        key: 'contacts',
        route: 'contacts',
        primaryCol: '_contact_id',
    };
    const baseURL = process.env.REACT_APP_BASE_URL;
    const { unique_id } = useParams(); // Get the client ID from the URL

  const inputFields = {
    contact_name: '',
    contact_client_id: '',
    contact_mobile: '',
    contact_email: '',
    contact_designation: '',
    contact_skills: '',
    contact_last_contacted: '',
    contact_meeting_mom: '',
  }
  const formatOptions = [
    {
      type: 'react-select',
      column: 'contact_client_id',
      labelColumn: 'client_name'
    },
    {
      type: 'react-datepicker',
      column: 'contact_last_contacted',
    }
  ];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate();

  const { state } = useAuth();
  let user_data = state.user_data;
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const [quickModals, setQuickModals] = useState({ clients: false });

  const [clients, setClients] = useState([]);
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const result = await getClients({user_token: user_data.user_token, page: 1, limit: -1});

        const clientOptions = result.clients.map(client => ({
          value: client._client_id,
          label: client.client_name
        }));

        setClients(clientOptions);
      } catch (error) {
        console.error(error);
      }
    };

    fetchClients();
  }, []);

//   const closeModal = () =>{
//     setId('');
//     setFields(inputFields);
//     setErrors({});

//     setShowModal(false);
//   }

  const validator = useRef(new SimpleReactValidator(validorSettings()));
  // Fetch the contact data when the component loads
  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await model.getSingleData({
          user_token: user_data.user_token,
          id: unique_id, // Assuming _client_id is the identifier in your data
        });

        if (response && response.poc) {
          //setFormData(response.data.client); // Assuming the response contains the client data
          console.log('poc data => ',response);
          //setFormData(response.primaryCol);
          setFields(formatDataBeforeDisplay(response.poc, formatOptions));
          setId(response.poc._contact_id);
        } else {
          toast.error("Contact not found.");
          navigate("/contacts"); // Redirect if client not found
        }
      } catch (error) {
        apiError(error);
        //console.error("Failed to fetch client data:", error);
        toast.error("Failed to fetch client data.");
      } finally {
        setLoading(false);
      }
    };

    fetchContactData();
  }, [unique_id, user_data.user_token, navigate]);
  const submit = async(e) => {
    e.preventDefault();

    if (! validator.current.allValid()) {
      toast.error('Please check the form errors!');
      return;
    }
    validator.current.hideMessages();
    
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);

      let response;
    //   if (data) {
        response = await model.update(user_data.user_token, id, formData);
    //   } else {
    //     response = await model.create(user_data.user_token, formData);
    //   }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        // closeModal();

        model.saveToStorage(response.data[module.key], response.data.pagination);
        // refreshData();
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    setLoading(false);
  }

  return (
    <>
    <AdminLayout>
    <Helmet>
        <title>{module.title} - Digital CMS</title>
      </Helmet>
      <div className="main-content app-content">
        <div className="container-fluid cms-form-shell">
        <PageHeader module={module}  />
        {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="row">
                <div className="col-xl-12">
                    <div className="card custom-card">
                        <div className="card-body">
                            <form onSubmit={submit}>
                            {(isView && checkPermission(module.route, 'edit'))? 
                              <div className="row gy-2 mb-3">
                                <div className="col-xl-11 "></div>
                                <div className="col-xl-1 ml-3" style={{ textAlign:"right" }}>
                                {checkPermission(module.route, 'edit') && (
                                  <button
                                    type="button"
                                    className="btn btn-icon btn-sm btn-info"
                                    title="Edit"
                                    onClick={() => navigate(`/contacts/${unique_id}/edit`)} // Navigate to the edit page
                                  >
                                    <i className='bx bxs-edit'></i>
                                  </button>
                                )}
                                </div>
                              </div>
                              : ''}
                            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <Text column="contact_name" disabled={isView} label="POC Name" required={true} fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-xl-4">
                <MyReactSelect column="contact_client_id" disabled={isView} label="Client" options={clients} required={true} fields={fields} setFields={setFields} errors={errors} validator={validator} rules="required" quickAddKey="clients" quickAddSet={setQuickModals} />
              </div>
              
              <div className="col-xl-4">
                <TextNumber column="contact_mobile" disabled={isView} label="Contact Number" required={true} fields={fields} setFields={setFields} errors={errors} validator={validator} rules="min:10|max:10" />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <TextEmail column="contact_email" disabled={isView} label="Email" required={true} fields={fields} setFields={setFields} errors={errors} validator={validator} rules='email' />
              </div>
              
              <div className="col-xl-4">
                <Text column="contact_designation" disabled={isView} label="Designation" fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-xl-4">
                <Text column="contact_skills" disabled={isView} label="LOB/Skills/Departments Managed" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <div className="form-input">
                  <DatePicker column="contact_last_contacted" disabled={isView} label="Last Contacted" fields={fields} setFields={setFields} errors={errors} pluginProps={{maxDate: new Date()}} />
                </div>
              </div>
              
              <div className="col-xl-4">
                <Text column="contact_meeting_mom" disabled={isView} label="MoM of the meeting" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>
            { isEdit ?
                      <button type="submit" className="btn btn-primary" disabled={loading} >
                        {loading ? "Updating..." : "Update Contact"}
                      </button>
                       : '' }
            
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-xl-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <h5 className="card-title mb-3">Links</h5>
                    <div className="row gy-2 mb-3">
                      <div className="col-md-2">
                        {/* <a href={`/requirements/?_contact_id=${id}`} className="btn w-100 btn-success">Requirements</a> */}
                        <Link to={`/requirements/?_contact_id=${id}`} className="btn w-100 btn-success">Requirements</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        )}
        </div>
        </div>
    </AdminLayout>
    </>
  );
};
